import { RawLocation } from 'vue-router'
import prop from 'vue-strict-prop'
import { component } from 'vue-tsx-support'

export default component({
	name: 'SidebarItem',
	props: {
		badge: prop(Number).optional,
		icon: prop(String).required,
		to: prop.ofType<RawLocation>().required,
	},
	render() {
		return (
			<router-link class="link item" to={this.to}>
				<i class={['large icon', this.icon]} />
				{this.$slots.default}
				{this.badge &&
					<div class="ui teal circular label">
						{this.badge}
					</div>
				}
			</router-link>
		)
	},
})
